import { Link } from "@tanstack/react-router";
import { SectionMark } from "@/components/section-mark";
import { latestArticles } from "@/content/latest-articles";
import { coverFor, coverZoomStyle } from "@/content/article-covers";


export function KnowledgeSection() {
  const visible = latestArticles;

  return (
    <section aria-labelledby="baza-heading" className="content-visibility-auto border-b border-ink/10">
      <div className="container-page section-pad">
        <div className="grid gap-8 md:grid-cols-[0.42fr_1fr] md:gap-12">
          <div>
            <SectionMark number="11" label="Psychologia biznesu" />
            <h2 id="baza-heading" className="display-xl mt-8 text-[1.9rem] md:text-[2.4rem]">
              Piszę o psychologii ludzi, od których dużo zależy.
            </h2>
            <Link to="/psychologia-biznesu" className="btn-base btn-outline mt-8 inline-flex">
              Wszystkie artykuły
            </Link>
          </div>
          <div>
          <ul className="stagger flex flex-col divide-y divide-steel border-y border-steel">
            {visible.map((article) => {
              const cover = coverFor(article.slug);
              return (
                <li key={article.slug}>
                  <Link
                    to={`/${article.slug}` as "/syndrom-oszusta"}
                    className="group grid gap-5 py-5 transition-colors hover:bg-surface sm:grid-cols-[minmax(0,11rem)_1fr] sm:items-center sm:gap-7 sm:px-4"
                  >
                    {cover ? (
                      <div className="photo-frame overflow-hidden">
                        <div style={coverZoomStyle(cover)}>
                          <img
                            src={cover.src}
                            alt={cover.alt}
                            loading="lazy"
                            decoding="async"
                            width={1200}
                            height={800}
                            style={{ objectPosition: cover.objectPosition }}
                            className="aspect-[3/2] w-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
                          />
                        </div>
                      </div>
                    ) : null}
                    <div>
                      <h3 className="text-base font-semibold leading-snug text-ink md:text-lg">
                        {article.h1}
                      </h3>
                      <p className="mt-2 text-sm leading-relaxed text-ink-soft">{article.teaser}</p>
                    </div>
                  </Link>
                </li>
              );
            })}
          </ul>
          </div>
        </div>

        <div className="mt-9 border border-steel bg-surface p-6 md:flex md:items-center md:justify-between md:gap-8">
          <div>
            <h3 className="text-lg font-semibold text-ink md:text-xl">
              Test na wypalenie zawodowe
            </h3>
            <p className="measure mt-3 text-base leading-relaxed text-ink/80">
              20 pytań, około 3 minuty, wynik od razu. Sprawdź, jak często pojawiają się u Ciebie
              sygnały przeciążenia. Test ma charakter edukacyjny i nie jest diagnozą.
            </p>
          </div>
          <Link
            to="/test-na-wypalenie-zawodowe"
            className="btn-base btn-primary mt-6 inline-flex shrink-0 md:mt-0"
          >
            Rozpocznij test
          </Link>
        </div>
      </div>
    </section>
  );
}
